export default function paginate(collection: any[], { page = 0, perPage = 20 }: { page: number; perPage: number }) {
  let start = page * perPage;
  let end = start + perPage;

  return collection.slice(start, end);
}
